<template>
	<span>
		<button class="flex-shrink-0 mr-8 align-middle whitespace-nowrap" @click="isOpen = !isOpen">
			<BaseIcon v-if="isOpen" name="mono/triangle-down" class="-ml-2 mr-4" />
			<BaseIcon v-else name="mono/triangle-right" class="-mt-3 -ml-2 mr-4" />
			<BaseIcon v-if="icon" :name="icon" class="w-10 h-10 mr-4" />
			<span v-if="constructorName" class="mr-4">{{ constructorName }}</span>
			<span v-if="!isOpen">
				{<template v-if="insidePreview || true">…</template>
				<template v-else>
					<span v-for="([key, prop], index) in preview" :key="index">
						<span class="mr-8">{{ key }}:</span>
						<ConsoleEventArg
							renderAs="ArgValue"
							:serialized="serialized"
							:value="prop"
							:class="{'break-all': wrap}"
							:wrap="wrap"
						/>
						<span v-if="index < 2">, </span>
						<span v-else-if="index === 2 && previewHasMore">, …</span>
					</span> </template
				>}
			</span>
			<span v-if="isOpen">{</span>
		</button>
		<div v-if="isOpen" style="margin-left: 20px">
			<div v-for="(prop, key) of value" :key="key" class="flex">
				<span class="mr-8">{{ key }}:</span>
				<ConsoleEventArg
					renderAs="ArgValue"
					:serialized="serialized"
					:value="prop"
					:insidePreview="insidePreview"
					:class="{'break-all': wrap}"
					:wrap="wrap"
				/>
			</div>
		</div>
		<div v-if="isOpen">}</div>
	</span>
</template>

<script>
export default {
	name: 'ArgObject',
	props: {
		serialized: Object,
		value: Object,
		constructorName: String,
		insidePreview: Boolean,
		icon: String,
		wrap: Boolean,
	},
	data() {
		return {
			isOpen: false,
		}
	},
	computed: {
		preview() {
			return Object.entries(this.value).slice(0, 3)
		},
		previewHasMore() {
			return Object.keys(this.value).length > 3
		},
	},
}
</script>
